// src/components/resumo/quiz/quiz.types.ts
// 🎯 Tipos do sistema de Quiz Embutido

export type QuizAlternative = 'a' | 'b' | 'c' | 'd';

export interface QuizQuestion {
    id: string;
    question: string;
    alternatives: {
        a: string;
        b: string;
        c: string;
        d: string;
    };
    correctAnswer: QuizAlternative;
    explanation?: string;
    order: number;
}

export interface QuizBadgeData {
    id: string;
    questions: QuizQuestion[];
    createdAt: string;
    updatedAt: string;
}

export interface QuizUserProgress {
    quizId: string;
    answeredQuestions: {
        [questionId: string]: {
            selectedAnswer: QuizAlternative;
            isCorrect: boolean;
            answeredAt: string;
        };
    };
}

export interface QuizBadgeProps {
    quizId: string;
    isEditMode: boolean;
    onClick?: () => void;
}

// Progresso do aluno num quiz específico — persistido (localStorage) para
// sobreviver à navegação entre páginas da apostila e a recarregamentos.
export interface QuizProgress {
    selectedAnswers: { [questionIndex: number]: QuizAlternative };
    score: number;
    currentQuestionIndex: number;
    completed: boolean;
}

export const DEFAULT_QUIZ_PROGRESS: QuizProgress = {
    selectedAnswers: {},
    score: 0,
    currentQuestionIndex: 0,
    completed: false,
};